// app/javascript/club/newsletter_modal.js

import onReady from '../../helpers/onReady'

// Variable globale pour éviter les initialisations multiples
window.newsletterModalInitialized = false;

// Fonction d'initialisation simplifiée
function initNewsletterModal() {
  // Vérifier si déjà initialisé
  if (window.newsletterModalInitialized) {
    return;
  }

  // Initializing newsletter modal
  
  // Supprimer les anciens gestionnaires d'événements
  $(document).off('submit.newsletter');
  $(document).off('click.newsletter', '.cancelNewsLetter');

  // Gestionnaire pour l'ouverture du modal newsletter
  $(document).on('submit.newsletter', '.trigger-newsletter-modal', function (e) {
    e.preventDefault();
    var emailInput = $('.newsletter-input');
    var emailInputFooter = $('.newsletter-input--footer');
    var emailValue = emailInput.val();
    var emailFormHidden = $('.email-hidden');

    if (emailValue != "" || emailInputFooter != "") {
        // Ne pas fermer les autres modales pour éviter les conflits
        
        // Nettoyer la modal avant de l'ouvrir
        var $modal = $('#newsletter_modal');
        
        // Nettoyer complètement la modal
        $modal.removeClass('hidden visible active dimmer');
        $modal.find('.content').removeClass('hidden');
        
        // S'assurer que la modal a les bonnes classes
        $modal.addClass('ui modal tiny custom-modal transition');
        
        // Réinitialiser le contenu du modal
        $modal.find('.content .text').html("");
        
        // Utiliser le système de modales unifié
        setTimeout(function() {
          window.modalManager.open('newsletter_modal');
        }, 200);
    }

    if((emailValue == "" || typeof emailValue === 'undefined') && emailInputFooter.length > 0) {
      emailValue = emailInputFooter.val();
    }

    emailFormHidden.val(emailValue);
    $('#newsletter_modal .content .text').html("Je souhaite recevoir la miamletter, la newsletter du Club Guy Demarle à l'adresse <strong>" + emailValue + "</strong>");
  });

  // Fonction pour fermer et nettoyer la modal
  function closeNewsletterModal() {
    window.modalManager.close('newsletter_modal');
    
    // Nettoyer les formulaires
    $('.trigger-newsletter-modal').get(0).reset();
    $('.js-trigger-modal').prop("disabled", false);
  }

  // Gestionnaire pour l'annulation du modal newsletter
  $(document).on('click.newsletter', '.cancelNewsLetter', function (e) {
    e.preventDefault();
    closeNewsletterModal();
  });

  // Gestionnaire pour le bouton de fermeture (X) de la modal
  $(document).on('click.newsletter', '#newsletter_modal .close.icon', function (e) {
    e.preventDefault();
    closeNewsletterModal();
  });

  // Gestionnaire pour le bouton de soumission
  $(document).on('click.newsletter', '.submitNewsLetter', function (e) {
    e.preventDefault();
    
    // Vérifier si le formulaire existe
    var $form = $('#newsletter_form');
    if ($form.length === 0) {
      return;
    }
    
    // Vérifier et corriger l'email avant soumission
    var emailInput = $('.newsletter-input');
    var emailInputFooter = $('.newsletter-input--footer');
    var emailValue = emailInput.val();
    
    if((emailValue == "" || typeof emailValue === 'undefined') && emailInputFooter.length > 0) {
      emailValue = emailInputFooter.val();
    }
    
    // Mettre à jour le champ caché avec l'email
    var $emailHidden = $('.email-hidden');
    $emailHidden.val(emailValue);
    
    // Désactiver le bouton pour éviter les clics multiples
    $(this).prop('disabled', true).addClass('loading');
    
    // Soumettre le formulaire
    $form.submit();
  });

  // Gestionnaire pour les événements AJAX
  $(document).on('ajax:success', '#newsletter_form', function (e, data, status, xhr) {
    // AJAX success
  });

  $(document).on('ajax:error', '#newsletter_form', function (e, xhr, status, error) {
    // AJAX error
  });

  // Le clic sur l'overlay est géré par le modal manager

  // Marquer comme initialisé
  window.newsletterModalInitialized = true;
}

// Initialiser au chargement du DOM
onReady(function() {
  initNewsletterModal();
});

// Initialiser aussi au chargement de Turbolinks si présent
$(document).on('turbolinks:load', function() {
  initNewsletterModal();
});

// Initialiser immédiatement si le DOM est déjà chargé
onReady(initNewsletterModal);
